<template>
  <div class="container">
    <div class="section">
      <label>Type:</label>
      <input disabled="disabled" value="Influencer" />
    </div>
    <div class="section">
      <label>Influencer ID:</label>
      <input v-model="influencerId" />
    </div>
    <div class="section">
      <label>Code:</label>
      <input v-model="shareableCode" placeholder="SHAREABLE_CODE" />
    </div>
    <div class="section">
      <label>Valid until:</label>
      <DatePicker v-model="expiresAt" mode="datetime" />
    </div>
    <div class="section">
      <label>Claims limit:</label>
      <input type="number" min="1" v-model="maxClaims" />
    </div>
    <div class="section">
      <label>Currency:</label>
      <select name="currency" v-model="currency">
        <option value="EUR">EUR</option>
        <option value="PLN">PLN</option>
      </select>
    </div>
    <div class="section">
      <label>Discount to the influencer ({{ currency }}):</label>
      <input type="number" step="0.01" v-model="influencerDiscountAmount" />
    </div>
    <div class="section">
      <label>Discount to the new user ({{ currency }}):</label>
      <input type="number" step="0.01" v-model="discountAmount" />
    </div>
    <p v-if="errorMessage" class="error">Error: {{ errorMessage }}</p>
    <button v-on:click="createCampaign()">Create campaign</button>
  </div>
</template>

<style scoped lang="less">
.container {
  padding: 50px;
}
label {
  margin-right: 20px;
}
input {
  padding: 10px;
}
.section {
  margin-bottom: 20px;
}
button {
  margin-top: 10px;
  border: 1px solid black;
  padding: 10px;
  cursor: pointer;
}
.error {
  color: red;
}
</style>


<script>
import api from "@/services/api";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
  name: "createReferralCampaign",
  components: { DatePicker },
  data() {
    const now = new Date();

    return {
      shareableCode: "",
      expiresAt: new Date(now.getFullYear(), now.getMonth() + 1, 0), // end of current month
      influencerId: "",
      maxClaims: 500,
      currency: "EUR",
      influencerDiscountAmount: 5,
      discountAmount: 20,

      errorMessage: "",
    };
  },
  methods: {
    async createCampaign() {
      try {
        await api.createInfluencerPromo({
          shareableCode: this.shareableCode,
          expiresAt: this.expiresAt.toISOString(),
          influencerId: this.influencerId,
          maxClaims: this.maxClaims,
          currency: this.currency,
          influencerDiscountAmount: this.influencerDiscountAmount * 100,
          discountAmount: this.discountAmount * 100,
        });
        this.$router.push("/campaigns");
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data) || `unexpected: ${error}`;
      }
    },
  },
};
</script>
